import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetRelatedSubscriptionAdsService extends Service {
  /**
   * @constructor
   * @param {Object} params
   * @param {HTTPAdsRepository} params.repository
   */
  constructor({repository}) {
    super()

    this._repository = repository
  }

  /**
   * @return {Promise<AdsValueObject, Error>} returns the related subscription ads to an specific ad id
   */
  @inlineError
  async execute(requestVO) {
    const [error, response] = await this._repository.getRelatedSubscriptionAds(requestVO)

    if (error) {
      return Promise.reject(error)
    }

    return response
  }
}
